import { isEmpty, isEqual } from 'lodash';
import moment from 'moment';
export const sortByDates = (a, b, granularity = 'days')=>{
    if (isEqual(a, b)) {
        return 0;
    }
    if (isEmpty(a)) {
        return -1;
    }
    if (isEmpty(b)) {
        return 1;
    }
    const date1 = moment(a);
    const date2 = moment(b);
    return date1.diff(date2, granularity);
};
